export default __webpack_public_path__ + "static/media/smile2.ba28dbf3.jpg";